import React, { useEffect, useState } from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Divider, IconButton, ListItemButton, Stack, Typography, Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { jwtDecode } from "jwt-decode";
import BusinessIcon from '@mui/icons-material/Business';
import { getOfficeById } from '../../../api/officeService';
import EditIcon from '@mui/icons-material/Edit';
import ClinicInfoForm from '../forms/ClinicInfoForm';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';

export default function ClinicInfo() {
    const [open, setOpen] = React.useState(false);

    const [formOpen, setFormOpen] = React.useState(false);
 
    const token = localStorage.getItem("accessToken");
    const officeId = jwtDecode(token).active_office_id;

    const [office, setOffice] = useState(null);

    const handleClickOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
    };

    const fetchOffice = async () => {
      const office = await getOfficeById(officeId);
      setOffice(office);
    }

    const handleEditClick = () => {
      setFormOpen(true);
    };

    const onUpdateSuccess = () => {
      fetchOffice();
    };

    useEffect(() => {
      if (open)
      {
        fetchOffice();
      }
    }, [open]);

    return (
        <React.Fragment>
        <ListItem>
            <ListItemButton onClick={handleClickOpen}>
            <ListItemIcon>
                <ContactPhoneIcon fontSize='large' color='secondary'/>
            </ListItemIcon>
            <ListItemText 
                primary="Clinic Contact Information"
                secondary="view and edit clinic email, contact number and address"
            />
            </ListItemButton>
        </ListItem>

        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            <DialogTitle>
            Clinic Contact Information
            </DialogTitle>
            <DialogContent>

              <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Name</Typography>
              <Typography variant="body1" sx={{ mt: 0 }}>{office?.name || "(none)"}</Typography>

              <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>E-mail</Typography>
              <Typography variant="body1" sx={{ mt: 0 }}>{office?.email || "(none)"}</Typography>
              
              <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Contact Number</Typography>
              <Typography variant="body1" sx={{ mt: 0 }}>{office?.contact_number || "(none)"}</Typography>

              <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Address</Typography>
              <Typography variant="body1" sx={{ mt: 0, whiteSpace: 'pre-line' }}>{office?.address || "(none)"}</Typography>

            </DialogContent>
            <DialogActions>
              <Button onClick={handleEditClick}>
                  <EditIcon />
              </Button>
              <div style={{flex: '1 0 0'}} />
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        <ClinicInfoForm 
          office={office}
          successCallback={onUpdateSuccess}
          open={formOpen}
          onClose={() => setFormOpen(false)}
        />
        </React.Fragment>
    );
}